import api from "./axios";

export class BaseRequests {
  // Set this to true to enable Bearer token, false to disable
  static useAuth = true;
  static getToken() {
    return localStorage.getItem("accessToken");
  }

  static getAuthHeaders() {
    if (this.useAuth) {
      const token = this.getToken();
      if (token) {
        return { Authorization: `Bearer ${token}` };
      }
    }
    return {};
  }

  static async get<T>(url: string, config = {}) {
    const response = await api.get<T>(url, {
      ...config,
      headers: { ...this.getAuthHeaders(), ...(config as any).headers },
    });
    return response.data;
  }

  static async post<T>(url: string, data?: any, config = {}) {
    const response = await api.post<T>(url, data, {
      ...config,
      headers: { ...this.getAuthHeaders(), ...(config as any).headers },
    });
    return response.data;
  }

  static async put<T>(url: string, data?: any, config = {}) {
    const response = await api.put<T>(url, data, {
      ...config,
      headers: { ...this.getAuthHeaders(), ...(config as any).headers },
    });
    return response.data;
  }

  static async patch<T>(url: string, data?: any, config = {}) {
    const response = await api.patch<T>(url, data, {
      ...config,
      headers: { ...this.getAuthHeaders(), ...(config as any).headers },
    });
    return response.data;
  }

  static async delete<T>(url: string, config = {}) {
    const response = await api.delete<T>(url, {
      ...config,
      headers: { ...this.getAuthHeaders(), ...(config as any).headers },
    });
    return response.data;
  }
}
